import controller from './search-bar.controller';
import template from './search-bar.html';

export default {
	template,
	controller,
	require: {
		list: '^^?listResults',
	},
};
